import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import CreateEvent from "@/pages/CreateEvent";
import EventPublic from "@/pages/EventPublic";
import EventManage from "@/pages/EventManage";
import EditEvent from "@/pages/EditEvent";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import ProductPage from "@/pages/ProductPage";

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/registro" element={<Register />} />
            <Route path="/recuperar" element={<ForgotPassword />} />
            <Route path="/restablecer/:token" element={<ResetPassword />} />
            <Route path="/productos/:id" element={<ProductPage />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/crear" element={<ProtectedRoute><CreateEvent /></ProtectedRoute>} />
            <Route path="/eventos/:id" element={<ProtectedRoute><EventManage /></ProtectedRoute>} />
            <Route path="/eventos/:id/editar" element={<ProtectedRoute><EditEvent /></ProtectedRoute>} />
            <Route path="/e/:slug" element={<EventPublic />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
      </AuthProvider>
    </div>
  );
}
